import { useState, useEffect, useRef } from "react";
import ImageMapper from "react-img-mapper";
import useSize from "@react-hook/size";

import { viewableUrlFile } from "../../utils/utilityFunction";
import "./Image.css";
import { Box, CircularProgress, Modal, Skeleton } from "@mui/material";
import ZoomableImage from "../ZoomableImage";
import fullScreen from "../../assets/icons/full-screen.png";

const Image = ({ image, playAudio, isLeft, isSmalllScreen, unitId }) => {
  const imageMapperRef = useRef();
  const newImg = useRef();
  const target = useRef(null);
  const [holderWidth, holderHeight] = useSize(target);
  const [width, setWidth] = useState(0);
  const [showZoomable, setShowZoomable] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [recalculate, setRecalculate] = useState(1);

  const [mapAreas, setMapAreas] = useState({
    name: `buttons-${image.id}`,
    areas: [],
  });

  useEffect(() => {
    let tempAreas = [];

    image?.buttons?.forEach((element) => {
      let temp = {
        areaKeyName: element.id,
        id: element.id,
        shape: "circle",
        coords: [element.x, element.y, element.r],
        fillColor: "rgba(255, 255, 255, 0)",
      };

      tempAreas.push(temp);
      //Add Pause Button
      // let pauseBtn = {
      //   id: element.id + "-pause",
      //   shape: "circle",
      //   coords: [element.x + 65, element.y, element.r + 2],
      //   fillColor: "rgba(255, 255, 255, 0.5)",
      // };
      // tempAreas.push(pauseBtn);
    });
    setMapAreas((prev) => ({ ...prev, areas: tempAreas }));
  }, [image?.buttons]);

  useEffect(() => {
    let tempH, tempW, newWidth;

    if (newImg.current) {
      tempH = newImg.current.height;
      tempW = newImg.current.width;

      newWidth = Math.ceil((holderHeight * tempW) / tempH);
      if (newWidth > holderWidth) {
        newWidth = holderWidth - 50;
      }
      if (newWidth) {
        setWidth(newWidth);
      } else {
        setRecalculate((i) => i + 1);
      }
    }
  }, [holderHeight, holderWidth, newImg, recalculate]);

  function handleButtonClick(evt) {
    let tempBtn = image?.buttons.find((btn) => btn.id === evt.id);
    let tempAudio = viewableUrlFile(tempBtn?.audio_url);
    playAudio(`${process.env.REACT_APP_FILE_LOCATION}${tempAudio}`);
  }

  useEffect(() => {
    setImageLoaded(false);
  }, [unitId, image?.id]);

  return (
    <Box
      sx={{
        maxWidth: isSmalllScreen ? "100%" : "50%",
        width: isSmalllScreen ? "100%" : "50%",
        maxHeight: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: isLeft ? "flex-end" : "flex-start",
        ...(isSmalllScreen && { alignItems: "center" }),
      }}
      ref={target}
    >
      <Modal open={showZoomable} onClose={() => setShowZoomable(false)}>
        <Box sx={modalStyle}>
          <ZoomableImage
            image={image}
            mapAreas={mapAreas}
            onClose={() => setShowZoomable(false)}
          />
        </Box>
      </Modal>
      <img
        ref={newImg}
        src={`${process.env.REACT_APP_FILE_LOCATION}${viewableUrlFile(
          image?.image_url
        )}`}
        alt="testImg"
        style={{ display: "none" }}
        onLoad={() => setImageLoaded(true)}
      />

      {!target.current || !holderHeight || !width || !imageLoaded ? (
        <>
          <Box className="spinnerSection">
            <CircularProgress
              sx={{ color: (theme) => theme.palette.primary.dark }}
              size={85}
            />
          </Box>
        </>
      ) : (
        <ImageMapper
          key={holderHeight + unitId}
          src={`${process.env.REACT_APP_FILE_LOCATION}${viewableUrlFile(
            image?.image_url
          )}`}
          map={mapAreas}
          height={!holderHeight ? 700 : holderHeight}
          parentWidth={!width ? 300 : width}
          responsive={true}
          containerRef={imageMapperRef}
          onClick={handleButtonClick}
        />
      )}
      {imageMapperRef.current && !isSmalllScreen && (
        <Box
          sx={{
            position: "absolute",
            ...(isLeft ? { left: "1px" } : { right: "1px" }),
            zIndex: 2,
            backgroundImage: `url(${fullScreen})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            cursor: "pointer",
            width: "40px",
            height: "40px",
          }}
          onClick={() => setShowZoomable(true)}
        />
      )}
    </Box>
  );
};

export default Image;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "97vw",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  height: "97vh",
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
};
